import FileUploadWithPreview from './FileUploadWithPreview';

export default FileUploadWithPreview;
